import { formatMoney } from "@stackline/ui";
import {
  ContentRewardCampaignForCarousel,
  SiteBrandingType,
} from "../../../../../../types/misc";
import FlowContainer from "../../components/FlowContainer";

import RewardFlowFinishButtons from "../../components/RewardFlowFinishButtons";
import { useSiteBrandingType } from "@/components/SiteProvider";
import { StoreFinish } from "@/components/StoreComponents/StoreFinish";

const Finish = ({
  content,
  receivedReward,
}: {
  content: ContentRewardCampaignForCarousel;
  receivedReward: number;
}) => {
  const siteBrandingType = useSiteBrandingType();
  const isDTC = siteBrandingType === SiteBrandingType.CustomDTCStore;
  const brandName = content?.brandclub?.name;
  const brandId = content?.brandclub?.brandId;
  const defaultSubtitle = `We appreciate your time. You earned a ${formatMoney(
    receivedReward
  )} reward That will be
    unlocked with your next purchase.`;
  return (
    <FlowContainer>
      <StoreFinish
        title="Thank you"
        subtitle={content?.content?.successSubtitle || defaultSubtitle}
        confettiProps={{ brandId: isDTC ? brandId : undefined }}
      >
        <RewardFlowFinishButtons brandName={brandName} brandId={brandId} />
      </StoreFinish>
    </FlowContainer>
  );
};

export default Finish;
